export const locale = {
  lang: 'vi-VN',
  data: {},
};
